import React from 'react';

const Education = () => {

    return (
        <div>
            <div className="col-md-12 mt-5" >
                <h1 className="mb-4 my-skill purple "><strong>Education</strong></h1>
                <div className="education w-100 m-auto text-center">
                    {/* <h3 className="mb-4 mt-5 under ">Under Graduation</h3> */}
                    <h4 className="">B.Sc in Electrical and Electronic Engineering,</h4>
                    <h5>
                        <span className="purple "> Eastern University </span> <small>, Dhaka</small>
                    </h5>

                    <p>Jan 2016 - Jan 2020</p>
                </div>
                <br />
                <div className="education w-100 m-auto text-center">
                    {/* <h3 className="mb-4 mt-5 under ">Under Graduation</h3> */}
                    <h4 className="">Higher Secondary School Certificate</h4>
                    <h5>
                        <span className="purple ">National Ideal College </span> <small>, Dhaka</small>
                    </h5>
                    <p>2014</p>
                </div>
                <br />
                <div className="education w-100 m-auto text-center">
                    {/* <h3 className="mb-4 mt-5 under ">Under Graduation</h3> */}
                    <h4 className="">Secondary School Certificate</h4>
                    <h5>
                        <span className="purple "> Ideal School and College </span> <small>, Dhaka</small>
                    </h5>
                    <p>2012</p>
                </div>
            </div>
        </div>


    );
};

export default Education;